import { render } from "./ProjectsView.vue?vue&type=template&id=7ee845d0&scoped=true&ts=true"
import script from "./ProjectsView.vue?vue&type=script&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&lang=ts"

import "./ProjectsView.vue?vue&type=style&index=0&id=7ee845d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee845d0"]])

export default __exports__